import { formatSalesOrderNumber } from '@zspace/format';
import { TemporaryAccessDashboardTableRow } from '@zspace/types';
import { formatExpiresAt } from '../../shared/utils';
import Link from '../../ui/link/link';
import PaginatedTable, {
  CustomPaginatedTableProps,
} from '../../ui/table/paginated-table/paginated-table';
import { Column } from '../../ui/table/types';

export type AdminTemporaryAccessManagementTableProps =
  CustomPaginatedTableProps<TemporaryAccessDashboardTableRow>;

export const columns: Column<TemporaryAccessDashboardTableRow>[] = [
  {
    key: 'so.number',
    title: 'Sales Order',
    className: 'is-width-15',
    render: (el) => (
      <Link to={`sales-orders/${el.salesOrder.id}`}>
        {formatSalesOrderNumber(el.salesOrder.number)}
      </Link>
    ),
    sortable: true,
  },
  {
    key: 'u.email',
    title: 'User',
    className: 'is-width-15',
    render: (el) => el.user.email,
    sortable: false,
  },
  {
    key: 'o.name',
    title: 'Opportunity name',
    className: 'is-width-20',
    render: (el) => el.salesOrder.opportunity?.name,
    sortable: true,
  },
  {
    key: 'a.name',
    title: 'Account',
    className: 'is-width-20',
    render: (el) => el.salesOrder.opportunity?.account?.name,
    sortable: true,
  },
  {
    key: 'aParent.name',
    title: 'Parent account',
    className: 'is-width-20',
    render: (el) => el.salesOrder.opportunity?.account?.parent?.name,
    sortable: true,
  },
  {
    key: 'expiresAt',
    title: 'Remaining days',
    className: 'is-width-10',
    render: (el) => formatExpiresAt(el.expiresAt),
    sortable: false,
  },
];

export function AdminTemporaryAccessManagementTable({
  form,
  dataSource,
  onChange,
  config,
  empty,
}: AdminTemporaryAccessManagementTableProps) {
  return (
    <PaginatedTable
      form={form}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      config={config}
      rowKey={'id'}
      empty={empty}
    />
  );
}

export default AdminTemporaryAccessManagementTable;
